/**
 * Error codes for DGI credential upload (must match backend).
 * Map these to translation keys in the UI.
 */
export const DGI_CREDENTIALS_ERROR_CODES = {
  CERTIFICATE_NO_RUC: 'CERTIFICATE_NO_RUC',
  CERTIFICATE_RUC_MISMATCH: 'CERTIFICATE_RUC_MISMATCH',
  CERTIFICATE_EXPIRED: 'CERTIFICATE_EXPIRED',
} as const;

export type DgiCredentialsErrorCode =
  (typeof DGI_CREDENTIALS_ERROR_CODES)[keyof typeof DGI_CREDENTIALS_ERROR_CODES];
